import { Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  AlertController,
  NavController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { Action } from "models/order-management/action";
import { OrderErrorResponse } from "models/order-management/models";
import { OrderResponse } from "models/order-management/orderResponse";
import CompanyResourceSummary from "models/resource-management/company-resource-summary";
import * as moment from "moment-timezone";
import { Subject } from "rxjs/Subject";
import { OrderPatchRequest } from "../../../../models/order-management/orderPatchRequest";
import { RejectedAction } from "../../../../models/order-management/rejectedAction";
import { OrderManagementDataService } from "../../../../providers/order-management-data-service/order-management-data-service";
import { UtilityService } from "../../../../providers/utility-service/utility-service";

@Component({
  selector: "reject-order",
  templateUrl: "reject-order.html",
})
export default class RejectOrder implements OnDestroy {
  providers: CompanyResourceSummary[] = [];
  providerSearchSubject: Subject<string> = new Subject();
  spinner: any = null;
  spinnerCounter: number = 0;
  patientChartId: number = 0;
  order: OrderResponse;
  userDisplayName: string;

  rejectForm: FormGroup;
  medicationName: string;
  orderId: number;
  orderingProviderId: number;
  signatureRequest: Action.SignatureRequestEnum;

  public constructor(
    private fb: FormBuilder,
    public navCtrl: NavController,
    private navParams: NavParams,
    private alertController: AlertController,
    public viewCtrl: ViewController,
    private orderManagementDataService: OrderManagementDataService,
    private utilService: UtilityService,
    private toastCtrl: ToastController
  ) {
    this.medicationName = this.navParams.data.name;
    this.orderId = this.navParams.data.orderId;
    this.userDisplayName = this.navParams.data.userDisplayName;
    this.orderingProviderId = this.navParams.data.orderingProviderId;
    this.signatureRequest = this.navParams.data.signatureRequest;
    this.rejectForm = new FormGroup({
      discontinueDate: this.fb.control(
        moment().format("MM/DD/YYYY"),
        Validators.required
      ),
      reason: this.fb.control("", Validators.required),
    });
  }

  ngOnDestroy(): void {}

  save(): void {
    let rejectedAction: RejectedAction = {
      actionType: Action.ActionTypeEnum.Rejected,
      reason: this.rejectForm.get("reason").value,
      orderingProviderId: this.orderingProviderId,
      orderingProviderDisplayName: this.userDisplayName,
      displayName: this.userDisplayName,
      timezone: moment.tz.guess(),
      signatureRequests: [this.signatureRequest],
    };
    let request: OrderPatchRequest = {
      ...rejectedAction,
    };
    this.utilService.increaseSpinnerCount("Saving...");
    this.orderManagementDataService
      .updateOrder(this.orderId.toString(), request)
      .finally(() => this.utilService.decreaseSpinnerCount())
      .subscribe(
        () => this.viewCtrl.dismiss({ shouldReload: true }),
        OrderErrorResponse.handleError(this.toastCtrl, "Error rejecting order.")
      );
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true, shouldReload: false });
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/provider-panel/reject-order/reject-order.ts